import { render, staticRenderFns } from "./SafetyObservationPriorityEditForm.vue?vue&type=template&id=49e08778"
import script from "./SafetyObservationPriorityEditForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationPriorityEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports